import { v4 as uuidv4 } from 'uuid';
import { Location } from '@la/types/models';
import { InternalServiceActivity } from 'domains/SiteLevelCalendar/types/InternalServiceActivity';
import baseApi from './baseApi';

export const siteLevelCalendarApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSiteActivities: builder.query<
      InternalServiceActivity[],
      {
        subdomain: string;
        requestData: {
          programIds?: string;
          startDateFrom?: string;
          startDateUpTo?: string;
        };
      }
    >({
      query: ({ subdomain, requestData }) => ({
        url: `/api/member-portal/${subdomain}/siteLevelCalendar/activities`,
        method: 'GET',
        headers: {
          'X-Request-ID': uuidv4(),
        },
        params: requestData,
      }),
    }),
    getSiteActivitiesPost: builder.query<
      InternalServiceActivity[],
      {
        subdomain: string;
        requestData: {
          parentProgramIds?: number[];
          startDateFrom?: string;
          startDateUpTo?: string;
        };
      }
    >({
      query: ({ subdomain, requestData }) => ({
        url: `/api/member-portal/${subdomain}/siteLevelCalendar/activities`,
        method: 'POST',
        headers: {
          'X-Request-ID': uuidv4(),
        },
        body: requestData,
      }),
    }),
    getSitePrograms: builder.query<any, { subdomain: string }>({
      query: ({ subdomain }) => ({
        url: `/api/member-portal/${subdomain}/siteLevelCalendar/programs`,
        method: 'GET',
        headers: {
          'X-Request-ID': uuidv4(),
        },
      }),
    }),
    getSiteLocations: builder.query<
      Location[],
      { subdomain: string; requestData?: { programId?: string } }
    >({
      query: ({ subdomain, requestData }) => ({
        url: `/api/member-portal/${subdomain}/siteLevelCalendar/locations`,
        method: 'GET',
        headers: {
          'X-Request-ID': uuidv4(),
        },
        params: requestData,
      }),
    }),
  }),
});

export const {
  useGetSiteActivitiesQuery,
  useGetSiteActivitiesPostQuery,
  useGetSiteProgramsQuery,
  useGetSiteLocationsQuery,
} = siteLevelCalendarApi;
